import { render } from "./RecommendList.vue?vue&type=template&id=267e44bb&scoped=true&ts=true"
import script from "./RecommendList.vue?vue&type=script&lang=ts"
export * from "./RecommendList.vue?vue&type=script&lang=ts"

import "./RecommendList.vue?vue&type=style&index=0&id=267e44bb&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267e44bb"]])

export default __exports__